module.exports = __webpack_public_path__ + "img/white-sync.b5ac6f32.svg";